<template>
  <div class="exportGoodsStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <div class="custom-date">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="searchForm.BeginTime">{{ searchForm.BeginTime }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="searchForm.EndTime">{{ searchForm.EndTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
        </van-col>
        <van-col class="colItem2">
          <div class="custom-country" @click="onShowEmit('exportGoodsStatisticsCountry')">
            <span v-if="searchForm.receiveCountryId">{{
              searchForm.receiveCountryName
            }}</span>
            <span v-else>{{ $t.exportGoodsStatistics.receiveCountry }}</span>
          </div>
          <van-button size="small" type="default" @click="onReset">{{
            $t.meta.reset
          }}</van-button>
        </van-col>
      </van-row>
    </div>

    <van-form>
      <ve-pie :data="chartData" :settings="chartSettings"></ve-pie>

      <div class="exportGoodsStatistics-radio">
        <div class="radio-label">{{ $t.exportGoodsStatistics.transportType }}</div>
        <van-radio-group
          v-model="searchForm.WB_Type"
          @change="onSearch"
          direction="horizontal"
        >
          <van-radio
            :name="item.value"
            v-for="(item, index) in wbTypeOptions"
            :key="index"
            >{{ item.label }}</van-radio
          >
        </van-radio-group>
      </div>
    </van-form>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.exportGoodsStatistics.hsCode }}：{{ item.HSCode }}
        </div>
        <div class="list-item">
          {{ $t.exportGoodsStatistics.goodsName }}：{{ item.GoodsName }}
        </div>
        <div class="list-item">
          {{ $t.exportGoodsStatistics.receiveCountry }}：{{ item.ReceiveCountry }}
        </div>
        <div class="list-item">
          {{ $t.exportGoodsStatistics.receiveCity }}：{{ item.DestinationCity }}
        </div>
        <div class="list-item">
          {{ $t.exportGoodsStatistics.transportType }}：{{ item.WB_TypeName }}
        </div>
      </div>
    </van-list>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <option-list
      event="exportGoodsStatisticsCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Row,
  Col,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(List)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "exportGoodsStatistics",
  components: {
    OptionList,
  },
  data() {
    return {
      searchForm: {
        BeginTime: "",
        EndTime: "",
        WB_Type: 0,
        receiveCountryName: "",
        receiveCountryId: null,
      },
      countryList: [],
      page: 0,
      pageSize: 10,
      wbTypeOptions: [
        {
          label: this.$t.meta.all,
          value: 0,
        },
        {
          label: this.$t.meta.wbType1,
          value: 1,
        },
        {
          label: this.$t.meta.wbType2,
          value: 2,
        },
        {
          label: this.$t.meta.wbType3,
          value: 3,
        },
        {
          label: this.$t.meta.wbType4,
          value: 4,
        },
        {
          label: this.$t.meta.wbType5,
          value: 5,
        },
      ],
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      showEndPicker: false,
      chartData: null,
      chartSettings: {
        offsetY: 250,
      },
    };
  },
  created() {
    this.initChartData();
    this.getCountryList();
    this.getExportGoodsStatistics();
  },
  methods: {
    getCountryList() {
      this.$api.customerManagement
        .getCountryList()
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CountryName + "," + item.CountryName_en,
              value: item.CountryId,
            };
            result.push(data);
          });
          this.countryList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCountry(item) {
      this.searchForm.receiveCountryName = item.text;
      this.searchForm.receiveCountryId = item.value;
    },
    initChartData() {
      this.chartData = {
        columns: ["type", "value"],
        rows: [],
      };
    },
    onSearch() {
      this.initChartData();
      this.getExportGoodsStatistics();
      this.initList();
      this.getList(1);
    },
    onReset() {
      this.searchForm.BeginTime = "";
      this.searchForm.EndTime = "";
      this.searchForm.receiveCountryName = "";
      this.searchForm.receiveCountryId = null;
      this.onSearch();
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.searchForm.BeginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.searchForm.EndTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getExportGoodsStatistics() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Type: this.searchForm.WB_Type,
        BeginTime: this.searchForm.BeginTime,
        EndTime: this.searchForm.EndTime,
        ReceiveCountryId: this.searchForm.receiveCountryId,
      };
      this.$api.dataSummary
        .getExportGoodsStatistics(param)
        .then((res) => {
          var items = res.data;
          var chartData = [];
          for (var item of items) {
            chartData.push({
              type: item.HSCode,
              value: item.TotalWeight,
            });
          }
          this.chartData.rows = chartData;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        WB_Type: this.searchForm.WB_Type,
        BeginTime: this.searchForm.BeginTime,
        EndTime: this.searchForm.EndTime,
        ReceiveCountryId: this.searchForm.receiveCountryId,
      };
      this.$api.dataSummary
        .getExportGoodsDetail(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.exportGoodsStatistics {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 42%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 42%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
            width: 15%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
      .colItem2 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        border-top: 1px solid #ebedf0;
        .custom-country {
          width: 74%;
          display: inline-block;
          text-align: center;
          font-size: 14px;
          padding: 10px;
          line-height: 33px;
          vertical-align: middle;
        }
        .van-button {
          vertical-align: middle;
          width: 15%;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .van-form {
    .ve-pie {
      padding: 20px 0px;
    }
    .exportGoodsStatistics-radio {
      padding-top: 0px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf0;
      .radio-label {
        color: #000;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .van-radio {
        margin-bottom: 10px;
        font-size: 12px;
        ::v-deep .van-radio__label {
          color: #646566;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
